var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M29.84 12.8H19.6a6.88 6.88 0 0 0-6.88 6.88v10.16a6.96 6.96 0 0 0 6.88 6.96h10.24a6.96 6.96 0 0 0 6.88-6.96V19.68a6.88 6.88 0 0 0-6.88-6.88zm4.4 17.04a4.48 4.48 0 0 1-4.4 4.48H19.6a4.48 4.48 0 0 1-4.4-4.48V19.68a4.48 4.48 0 0 1 4.4-4.48h10.24a4.48 4.48 0 0 1 4.4 4.48v10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "M24.72 19.2a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2zm0 8.56a3.04 3.04 0 1 1 .003-6.08 3.04 3.04 0 0 1-.003 6.08zm6.24-10.96a1.68 1.68 0 1 0 .004 3.361 1.68 1.68 0 0 0-.004-3.361z"
  }))));
};
export default SvgInstagram;